import { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { Card, CardBody, CardText, CardTitle } from 'reactstrap';
class Transaction extends Component {
  constructor(props) {
    super(props);
    const { aboutProps } = this.props.location;
    const name = aboutProps && aboutProps.name || ""
    this.howToBuyRef = createRef();
    this.paymentMethodRef = createRef();
    this.installmentsRef = createRef();
    this.orderSentRef = createRef();
    this.returnSneakersRef = createRef();
    this.refundPaymentRef = createRef();
    this.trackOrderRef = createRef();
    this.howToOfferRef = createRef();
    this.complaintRef = createRef();
    this.cancelledOrderRef = createRef()

    this.state = {
      name
    };
  }

  componentDidUpdate(prevProps) {
    const { aboutProps } = prevProps.history.location;
    const name = aboutProps && aboutProps.name;
    const { dataSection } = this.props;

    // if (prevProps.dataSection !== this.props.dataSection) {
    if (dataSection === "how-to-buy") {
      window.scrollTo({
        top: this.howToBuyRef.current.getBoundingClientRect().top - 170,
        behavior: "smooth"
      });
    }
    if (dataSection === "payment-method") {
      window.scrollTo({
        top: this.paymentMethodRef.current.getBoundingClientRect().top - 170,
        behavior: "smooth"
      });
    }
    if (dataSection === "installments-step") {
      window.scrollTo({
        top: this.installmentsRef.current.getBoundingClientRect().top - 170,
        behavior: "smooth"
      });
    }
    if (dataSection === "order-sent") {
      window.scrollTo({
        top: this.orderSentRef.current.getBoundingClientRect().top - 170,
        behavior: "smooth"
      });
    }
    if (dataSection === "return-sneakers") {
      window.scrollTo({
        top: this.returnSneakersRef.current.getBoundingClientRect().top - 170,
        behavior: "smooth"
      });
    }
    if (dataSection === "refund-payment") {
      window.scrollTo({
        top: this.refundPaymentRef.current.getBoundingClientRect().top - 170,
        behavior: "smooth"
      });
    }
    if (dataSection === "track-order") {
      window.scrollTo({
        top: this.trackOrderRef.current.getBoundingClientRect().top - 170,
        behavior: "smooth"
      });
    }
    if (dataSection === "how-to-offer") {
      window.scrollTo({
        top: this.howToOfferRef.current.getBoundingClientRect().top - 170,
        behavior: "smooth"
      });
    }
    if (dataSection === "complaint") {
      window.scrollTo({
        top: this.complaintRef.current.getBoundingClientRect().top - 170,
        behavior: "smooth"
      });
    }
    if (dataSection === "cancel-order") {
      this.cancelledOrderRef.current.scrollIntoView({ behavior: "smooth", block: "center" })
    }
    // }
  }

  componentDidMount() {
    if (this.state.name === "how-to-buy") {
      window.scrollTo({
        top: this.howToBuyRef.current.getBoundingClientRect().top - 170,
        behavior: "smooth"
      });
    }
    if (this.state.name === "payment-method") {
      window.scrollTo({
        top: this.paymentMethodRef.current.getBoundingClientRect().top - 170,
        behavior: "smooth"
      });
    }
    if (this.state.name === "installments-step") {
      window.scrollTo({
        top: this.installmentsRef.current.getBoundingClientRect().top - 170,
        behavior: "smooth"
      });
    }
    if (this.state.name === "order-sent") {
      window.scrollTo({
        top: this.orderSentRef.current.getBoundingClientRect().top - 170,
        behavior: "smooth"
      });
    }
    if (this.state.name === "return-sneakers") {
      window.scrollTo({
        top: this.returnSneakersRef.current.getBoundingClientRect().top - 170,
        behavior: "smooth"
      });
    }
    if (this.state.name === "refund-payment") {
      window.scrollTo({
        top: this.refundPaymentRef.current.getBoundingClientRect().top - 170,
        behavior: "smooth"
      });
    }
    if (this.state.name === "track-order") {
      window.scrollTo({
        top: this.trackOrderRef.current.getBoundingClientRect().top - 170,
        behavior: "smooth"
      });
    }
    if (this.state.name === "how-to-offer") {
      window.scrollTo({
        top: this.howToOfferRef.current.getBoundingClientRect().top - 170,
        behavior: "smooth"
      });
    }
    if (this.state.name === "complaint") {
      window.scrollTo({
        top: this.complaintRef.current.getBoundingClientRect().top - 170,
        behavior: "smooth"
      });
    }
    if (this.state.name === "cancel-order") {
      this.cancelledOrderRef.current.scrollIntoView({ behavior: "smooth", block: "center" })
    }
  }
  render() {

    const { dataFAQ } = this.props

    const subDataFAQ = dataFAQ && dataFAQ[1]

    return (
      <div id="helps-container">
        <p className="title-card">{dataFAQ && dataFAQ[1].name}</p>
        <div ref={this.howToBuyRef}>
          <Card>
            <CardBody>
              <CardTitle>Bagaimana cara melakukan pembelian ?</CardTitle>
              <CardText>
                Berikut merupakan beberapa tahap untuk melakukan pemesanan:
                <ol>
                  <li>Telusuri daftar sneakers yang tersedia di Kick Avenue sesuai keinginan Anda, lalu pilih produk yang anda inginkan dan pilih ukuran yang sesuai</li>
                  <li>Pilih kategori barang yang Anda inginkan dengan detail sebagai berikut:
                    <ul>
                      <li>Brand New = Produk dengan kondisi baru dan ready stock (tersedia)</li>
                      <li>Used = Produk dengan kondisi sudah pernah digunakan / bekas</li>
                      <li>Pre Order = Produk dengan kondisi baru namun tidak ready stock, perlu dilakukan pemesanan terlebih dahulu  ketika adanya pembelian</li>
                    </ul>
                  </li>
                  <li>Ketik tombol Buy Now / Beli dan Anda akan diarahkan ke info Kontak dan Penagihan. Pastikan lengkapi semua informasi sebelum Anda menekan tombol  Place Order / Tempatkan Pemesanan.</li>
                  <li>Pastikan anda melakukan pembayaran sesuai dengan tenor waktu yang diberikan untuk meneruskan proses pembelian.</li>
                  <li>Anda dapat mengunjungi: <a href="https://www.youtube.com/watch?v=-6h7NLJkOcs&feature=youtu.be">https://www.youtube.com/watch?v=-6h7NLJkOcs&feature=youtu.be</a> untuk cara pembelian lebih detail</li>
                  <li>Perlu diketahui untuk produk-produk yang umum dan diproduksi secara massal terkadang ada sedikit kecacatan dari pihak pabrik masing-masing tetapi produk tersebut tetap layak dipakai.</li>
                  <li>Untuk pengiriman dari pihak Kick Avenue tarif pengiriman yang dikenakan akan berdasarkan dari volume box yang kita sediakan.</li>
                </ol>
              </CardText>
            </CardBody>
          </Card>
        </div>
        <div ref={this.paymentMethodRef}>
          <Card>
            <CardBody>
              <CardTitle>Apa metode pembayaran di Kick Avenue ?</CardTitle>
              <CardText>
                Kami menerima pembayaran dengan Kick Credit dan/atau Seller Credit, Bank Transfer, Kartu Kredit berdasarkan prinsip VISA, MasterCard, dan / atau JCB, Transfer Bank Virtual Account, dan cicilan melalui layanan kartu kredit yang tersedia. Semua pembayaran dijamin oleh mitra gateway pembayaran tepercaya dan sah.
              </CardText>
            </CardBody>
          </Card>
        </div>
        <div ref={this.installmentsRef}>
          <Card>
            <CardBody>
              <CardTitle>Bagaimana cara mengajukan angsuran / cicilan ?</CardTitle>
              <CardText>
                Kick Avenue telah bekerja sama dengan berbagai Bank dan lembaga keuangan lainnya untuk mengakomodasi kemampuan Anda. Harap dicatat bahwa institusi yang berbeda akan memberikan Anda tingkat angsuran yang berbeda.
              </CardText>
            </CardBody>
          </Card>
        </div>
        <div ref={this.cancelledOrderRef}>
          <Card>
            <CardBody>
              <CardTitle>Bagaimana cara membatalkan pesanan ?</CardTitle>
              <CardText>
                Kami hanya menerima pembatalan dalam waktu 3 jam dari pesanan anda atau sebelum penjual melakukan konfirmasi persetujuan pesanan, hal ini terjadi tergantung dari tindakan apa yang dilakukan terlebih dahulu. Jika anda menginginkan pembatalan, harap langsung menghubungi tim di line @kickavenue.
              </CardText>
            </CardBody>
          </Card>
        </div>
        <div ref={this.orderSentRef}>
          <Card>
            <CardBody>
              <CardTitle>Berapa lama barang bisa dikirim ?</CardTitle>
              <CardText>
                Proses pengiriman yang dilakukan adalah sebagai berikut:
              <ol>
                  <li>Setelah pesanan selesai, sistem kami akan menginformasikan penjual dalam waktu 3 jam.</li>
                  <li>Penjual akan mengirimkan barang yang terjual ke gudang Kick Avenue untuk diverifikasi dan diautentikasi.</li>
                  <li>Proses pengiriman ini biasanya membutuhkan waktu paling lama 48 jam untuk penjual mengirimkan resi dan produk ke tim Kick Avenue.</li>
                  <li>Adanya penundaan kemungkinan besar disebabkan oleh adanya anomali pada produk.</li>
                  <li>Lama pengiriman tergantung pada pilihan metode pengiriman dan jarak / lokasi alamat Anda.</li>
                  <li>Pengiriman keseluruhan standar kami memakan waktu 3-7 hari kerja sampai produk tiba di alamat Anda.</li>
                </ol>
              </CardText>
            </CardBody>
          </Card>
        </div>
        <div ref={this.returnSneakersRef}>
          <Card>
            <CardBody>
              <CardTitle>Bagaimana cara mengembalikan barang ?</CardTitle>
              <CardText>
                Kami mohon maaf atas ketidaknyamanan yang terjadi pada Anda, untuk hal ini Kick Avenue hanya menerima pengembalian produk <strong>Brand New</strong> tetapi pengembalian produk <strong>tidak</strong> akan berlaku jika ada kondisi cacat minor manufaktur produk maupun box (Foto lampiran di bawah), dan tidak berlaku untuk <strong>Penukaran Ukuran (Size)</strong> seperti sepatu ketika terjadi kesalahan memilih ukuran (size) ataupun mengenai <strong>Perbedaan Harga</strong> produk sewaktu pembelian. Untuk pre-order, kami tidak menerima pengembalian atas alasan apapun selain garansi autentikasi. Kami akan menunggu 2 x 24 jam dari tanggal Anda menerima produk sampai Anda meminta pengembalian dengan kondisi produk yang tepat, kami akan mengembalikan dana transaksi Anda dengan jumlah lebih sedikit dengan biaya pengiriman, max. 2 hari kerja. Mohon dibaca dan apakah produk anda memenuhi persyaratan sebagai berikut untuk proses pengembalian:
              <ol>
                  <li>Menginformasikan ke Customer Service dari Line@ untuk meminta form pengembalian barang.</li>
                  <li>Pastikan Anda telah mendapatkan konfirmasi dan persetujuan dari CS mengenai pengembalian produk Anda.</li>
                  <li>Produk yang dikembalikan tidak dalam keadaan rusak/cacat dan kotor, memiliki kondisi yang sama persis dengan kondisi aslinya saat tim Kick Avenue mengirimkan.</li>
                  <li>Kondisi produk yang dimaksud adalah: Tag Kick Avenue tidak terlepas dari produk tersebut, Box / Packaging produk tidak rusak atau sesuai dengan kondisi yang dikirimkan.</li>
                  <li>Harap mengirimkan produk dalam waktu 2 hari sejak produk tiba.</li>
                  <li>Kirimkan tanda terima pengiriman dan nomor pengiriman ke info@kickavenue.com atau Line@.</li>
                  <li>Kick Avenue memiliki keputusan akhir apapun mengenai pengembalian produk dan pengembalian dana.</li>
                </ol>
              </CardText>
            </CardBody>
          </Card>
        </div>
        <div ref={this.refundPaymentRef}>
          <Card>
            <CardBody>
              <CardTitle>Bagaimana proses pengembalian dana atas kendala pesanan Anda ?</CardTitle>
              <CardText>
                Pengembalian dana atas kendala pesanan yang dialami akan ditransfer ke masing - masing payment method yang terpilih pada transaksi Anda. Untuk pencairan dana ke rekening Bank, anda dapat melakukan pilihan disbursement pada akun Kick Avenue anda dan masa waktu pengembalian dana tergantung pada jenis pembayaran yang anda gunakan. Lama waktu pengembalian dana adalah sebagai berikut:
              <ol>
                  <li>Pengembalian dana pada rekening bank yang sama: 1 hari kerja.</li>
                  <li>Pengembalian dana antar rekening bank / pada bank yang berbeda (crossbank): 2 - 3 hari kerja. </li>
                  <li>Pengembalian dana pada Kartu Kredit / Debit Online : 14 hari kerja (sesuai dengan ketentuan bank pada umumnya).</li>
                </ol>
              </CardText>
            </CardBody>
          </Card>
        </div>
        <div ref={this.trackOrderRef}>
          <Card>
            <CardBody>
              <CardTitle>Bagaimana cara melacak pesanan saya ?</CardTitle>
              <CardText>
                Kick Avenue memiliki sistem otomatis yang akan terus memperbarui Anda mengenai pesanan Anda karena sedang ditempatkan. Anda dapat membuka tab 'Pesanan Saya' untuk memeriksa riwayat pembelian Anda dan melacak pesanan Anda yang sedang berlangsung. Untuk status - status pada pesanan Anda, dapat dijelaskan sebagai berikut:
              <ul>
                  <li>Waiting seller confirmation: Menunggu penjual mengkonfirmasi pesanan Anda.</li>
                  <li>Waiting seller delivering: Menunggu penjual mengirimkan produk Anda ke warehouse Kick Avenue.</li>
                  <li>En route to Kick Avenue: Produk sudah dikirimkan oleh penjual dan sedang menuju warehouse Kick Avenue.</li>
                  <li>Verification progress: Produk sudah diterima dan sedang dalam proses autentikasi dan verifikasi oleh tim Kick Avenue.</li>
                  <ol style={{ marginLeft: "15px" }}>
                    <li>Verification passed: Produk Anda sudah lolos dalam tahap autentikasi dan akan dilanjutkan pada tahap pengiriman.</li>
                    <li>Under Review: Produk Anda sedang dalam proses penelitian lebih lanjut mengenai autentikasi dari produk Anda.</li>
                    <li>Verification failed: Produk Anda tidak lolos dalam tahap autentikasi dan akan dilanjutkan pada tahap pengembalian dana.</li>
                  </ol>
                  <li>Delivering: Produk Anda sedang dalam proses pengiriman ke alamat Anda.</li>
                  <li>Refunded: Produk Anda tidak lolos autentikasi dan verifikasi sehingga dana akan dikembalikan kepada Anda.</li>
                  Untuk informasi lebih lanjut, harap menghubungi customer service di Whatsapp pada pukul <strong>10.00 - 21.00 untuk Weekdays</strong> dan <strong>10.00 - 17.00 untuk Weekend</strong> (kami tidak melayani pada waktu libur nasional / tanggal merah).
              </ul>
              </CardText>
            </CardBody>
          </Card>
        </div>
        <div ref={this.howToOfferRef}>
          <Card>
            <CardBody>
              <CardTitle>Dapatkah saya melakukan tawar menawar ?</CardTitle>
              <CardText>
                Kick Avenue telah menyediakan fitur Make Offer / Penawaran untuk memastikan setiap pembelian sesuai dengan harga yang anda inginkan. Penawaran yang dilakukan memerlukan Top Up  Anda untuk menawar produk yang Anda inginkan. Apabila penjual melihat penawaran anda dan ingin menjual barangnya sesuai dengan apa yang anda tawarkan, maka proses jual-beli akan terjadi.
              </CardText>
            </CardBody>
          </Card>
        </div>
        <div ref={this.complaintRef}>
          <Card>
            <CardBody>
              <CardTitle>Bagaimana mengajukan keluhan ?</CardTitle>
              <CardText>
                Kami mohon maaf jika kami tidak memenuhi standar yang Anda inginkan, mohon informasikan kami mengenai keluhan Anda agar kami dapat terus meningkatkan kualitas dan pengalaman berbelanja Anda. Kirimkan pertanyaan dan keluhan Anda ke customer service di Whatsapp atau email ke info@kickavenue.com. Customer service kami akan segera melayani Anda pada pukul <strong>10.00 - 21.00 untuk Weekdays</strong> dan <strong>10.00 - 17.00 untuk Weekend</strong> (kami tidak melayani pada waktu libur nasional / tanggal merah).
              </CardText>
            </CardBody>
          </Card>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  dataSection: state.dataMenu.section_name,
  dataFAQ: state.dataMenu.faqs.data
});

export default connect(mapStateToProps, null)(Transaction)